"use strict";
/**
 * Chart-of-accounts type matching for Handshake mapping slots.
 * Xero and QuickBooks use different type strings for the same kind of account.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccountingContractLiabilityAccountType = isAccountingContractLiabilityAccountType;
exports.isAccountingRevenueIncomeAccountType = isAccountingRevenueIncomeAccountType;
function compactAccountingAccountType(type) {
    return (type ?? "").trim().toUpperCase().replace(/[_-\s]+/g, "");
}
/** Xero LIABILITY / CURRLIAB / TERMLIAB and QBO Other Current / Long Term Liability. */
const CONTRACT_LIABILITY_ACCOUNT_TYPES = new Set([
    "LIABILITY",
    "CURRLIAB",
    "TERMLIAB",
    "CURRENTLIABILITY",
    "OTHERCURRENTLIABILITY",
    "OTHERCURRENTLIABILITIES",
    "LONGTERMLIABILITY",
    "LONGTERMLIABILITIES",
]);
/** Xero REVENUE / SALES / OTHERINCOME and QBO Income / Other Income. */
const REVENUE_INCOME_ACCOUNT_TYPES = new Set([
    "REVENUE",
    "SALES",
    "OTHERINCOME",
    "INCOME",
    "OPERATINGREVENUE",
    "OTHERCURRENTINCOME",
]);
function isAccountingContractLiabilityAccountType(type) {
    const compact = compactAccountingAccountType(type);
    return compact.length > 0 && CONTRACT_LIABILITY_ACCOUNT_TYPES.has(compact);
}
/** True when the chart account is Income/Revenue (DEFAULT_REVENUE slot — HAN-461). */
function isAccountingRevenueIncomeAccountType(type) {
    const compact = compactAccountingAccountType(type);
    return compact.length > 0 && REVENUE_INCOME_ACCOUNT_TYPES.has(compact);
}
